import { StaffBonus } from "@/actions/ssr/staff-management/getStaffBonusSSR";
import { createSlice } from "@reduxjs/toolkit";

export interface StaffBonusState {
  staffBonus: StaffBonus[];
  staffBonusLoading: boolean;
  selectedStaffBonus: StaffBonus | null;

  // Backend pagination info
  staffBonusPagination: {
    count: number;
    next: string | null;
    previous: string | null;
  };

  // Staff members for account dropdown (simplified)
  staffAccounts: Array<{
    id: number;
    full_name: string;
  }>;

  //create or edit dialog state
  staffBonusCreateEditDialogOpen: {
    open: boolean;
    openFor: "create" | "edit" | "view";
    editItemData?: Partial<StaffBonus>;
  };

  staffBonusCreateEditLoading: boolean;
  staffBonusCreateEditError: string | null;
  staffBonusDeleteLoading?: {
    loading: boolean;
    deleteItemId?: number;
  };

  isStaffBonusDialogOpen: {
    open: boolean;
    deleteItemId: number | undefined;
  };
}

const initialState: StaffBonusState = {
  // Staff bonus from API
  staffBonus: [],
  staffBonusLoading: false,
  selectedStaffBonus: null,

  // Backend pagination info
  staffBonusPagination: {
    count: 0,
    next: null,
    previous: null,
  },

  // Staff members for account dropdown (simplified)
  staffAccounts: [],

  //create or edit dialog state
  staffBonusCreateEditDialogOpen: {
    open: false,
    openFor: "create",
    editItemData: undefined,
  },

  staffBonusCreateEditLoading: false,
  staffBonusCreateEditError: null,
  staffBonusDeleteLoading: {
    loading: false,
    deleteItemId: undefined,
  },

  isStaffBonusDialogOpen: {
    open: false,
    deleteItemId: undefined,
  },
};

export const staffBonusSlice = createSlice({
  name: "staffBonus",
  initialState,
  reducers: {
    setStaffBonus: (state, action) => {
      state.staffBonus = action.payload;
    },
    setStaffBonusLoading: (state, action) => {
      state.staffBonusLoading = action.payload;
    },
    setStaffBonusPagination: (state, action) => {
      state.staffBonusPagination = action.payload;
    },

    setStaffAccounts: (state, action) => {
      state.staffAccounts = action.payload;
    },

    //create or edit dialog state
    setStaffBonusCreateEditDialogOpen: (state, action) => {
      state.staffBonusCreateEditDialogOpen = action.payload;
    },

    clearStaffBonusCreateEditDialogOpen: (state) => {
      state.staffBonusCreateEditDialogOpen = {
        open: false,
        openFor: "create",
        editItemData: undefined,
      };
    },

    setStaffBonusCreateEditLoading: (state, action) => {
      state.staffBonusCreateEditLoading = action.payload;
    },

    setStaffBonusCreateEditError: (state, action) => {
      state.staffBonusCreateEditError = action.payload;
    },

    setStaffBonusDeleteLoading: (state, action) => {
      state.staffBonusDeleteLoading = action.payload;
    },

    setIsStaffBonusDialogOpen: (state, action) => {
      state.isStaffBonusDialogOpen = action.payload;
    },

    setSelectedStaffBonus: (state, action) => {
      state.selectedStaffBonus = action.payload;
    },
  },
});

export const {
  setStaffBonus,
  setStaffBonusLoading,
  setStaffBonusPagination,
  setStaffAccounts,
  setStaffBonusCreateEditDialogOpen,
  clearStaffBonusCreateEditDialogOpen,
  setStaffBonusCreateEditLoading,
  setStaffBonusCreateEditError,
  setStaffBonusDeleteLoading,
  setIsStaffBonusDialogOpen,
  setSelectedStaffBonus,
} = staffBonusSlice.actions;

export default staffBonusSlice.reducer;
